import { render, staticRenderFns } from "./SaleLedger.vue?vue&type=template&id=0eb80480&"
import script from "./SaleLedger.vue?vue&type=script&lang=js&"
export * from "./SaleLedger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports